import { Box, Typography, CircularProgress, useMediaQuery } from "@mui/material";
import StatusBadge from "../../../v2/MUI_custom_component/Badge/StatusBadge";
import { CustomButton } from "../../../v2/MUI_custom_component";
import dayjs from 'dayjs';
import IllustrationWrapper from "../../Illustrration/IllustrationWrapper";
import NoDataFoundSvg from "../../Illustrration/components/NoDataFoundSvg";
import IconReusable from "../../../components/IconReusable";
import { toCapitalized } from "../../../v2/Utils/Capitalize";
import { useNavigate } from "react-router-dom";
import { ORDER_STATUS } from "../../../utils/settings";
import { resetDP } from "../../DP/CreateDP/reducer/DpActions";
import { useDispatch } from "react-redux";

const AttachedDPList = ({ attachedDPData, loading, isViewAttachedDPData, selectedStatus=[], hasMore = false }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isMobile = useMediaQuery('(max-width: 1200px)');
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {attachedDPData && attachedDPData.length > 0 ? (
                <Box sx={{ display: 'flex', 
                    flexDirection: 'column',
                    borderRadius: 2, 
                    px: 2,
                    backgroundColor: '#fff', 
                }}>
                    {attachedDPData.map((dp, index) => (
                        <Box key={dp.order_id || index} sx={{ 
                            borderBottom: index < attachedDPData.length - 1 ? '1px solid #D9D9D9' : 'none',
                            py: 2,
                            display: 'flex',
                            gap: { xs: 0.5, md: 0 },
                            flexDirection: { xs: 'column', md: 'row'}
                        }}>
                            
                            <Box sx={{ borderRight: { md: '1px solid #D9D9D9'}, display: 'flex', flexDirection: { xs: 'row', md: 'column'}, minWidth: { md: '200px'}, gap: 1 , justifyContent: {xs: 'space-between', md: 'flex-start'}, alignItems: 'flex-start', pr: { md: 2 }}}>
                                <Box sx={{ display: 'flex',flexDirection: 'column', gap: 1,}}>
                                <Typography variant="bodyL">
                                    {dayjs(dp.date).format('DD MMM YYYY')}
                                </Typography>
                                { !isViewAttachedDPData && dp.user_booking_id && (
                                    <Box sx={{ display: {xs:'flex', md: 'none'},flexDirection: {xs: 'row', md:'column'}, gap: 1, alignItems: { xs: 'center', md: 'flex-start' }}}>
                                        <Typography variant="labelM" sx={{ color: '#666'}}>
                                            User PO No.
                                        </Typography>
                                        <Typography variant="p3">
                                            {dp.user_booking_id}
                                        </Typography>
                                    </Box>
                                )}
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, }}>
                                    <Box sx={{ display: 'flex',flexDirection: {xs: 'row', md:'row'}, gap: 2,}}>
                                        <Box sx={{ display: 'flex',flexDirection: {xs: 'row', md:'column'}, gap: 1, alignItems: { xs: 'center', md: 'flex-start' }}}>
                                            <Typography variant="labelM" sx={{ color: '#666'}}>
                                                Order ID
                                            </Typography>
                                            <Typography variant="p3">
                                                {dp.order_id}
                                            </Typography>
                                        </Box>
                                        { !isViewAttachedDPData && dp.user_booking_id && (
                                            <Box sx={{ display: {xs:'none', md: 'flex'},flexDirection: {xs: 'row', md:'column'}, gap: 1, alignItems: { xs: 'center', md: 'flex-start' }}}>
                                                <Typography variant="labelM" sx={{ color: '#666'}}>
                                                    User PO No.
                                                </Typography>
                                                <Typography variant="p3">
                                                    {dp.user_booking_id}
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                    <Box sx={{ display:{xs: 'flex', md:  'none'}, justifyContent: 'end' }}>
                                        <StatusBadge 
                                            label={dp.order_status}
                                            status={dp.order_status}
                                            size="small"
                                        />
                                    </Box>
                                </Box>
                            </Box>
                            
                            <Box sx={{ width: '100%', pl:{ md:  2 }, display: 'flex', flexDirection: 'column', gap: 1 }}> 
                                <Box sx={{ display: 'flex', justifyContent : 'space-between', alignItems: 'flex-start', width: '100%' }}>
                                    {dp.ship_to_parties && dp.ship_to_parties.length > 0 && (
                                        <Box sx={{ display: 'flex', gap: {md: 1}, flexDirection: { xs: 'column', md:'row'}, }}>
                                            <Typography variant="labelM" sx={{ color: '#666' }}>
                                                Ship to Party
                                            </Typography>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    {dp.ship_to_parties.map((party, pIndex) => (
                                                        <Box key={pIndex} sx={{ display: 'flex' }}>
                                                            <Typography variant="bodyL">
                                                                {toCapitalized(party.company_name)}
                                                            </Typography>
                                                            {pIndex < dp.ship_to_parties.length - 1 && (
                                                                <Typography variant="bodyL" sx={{ mx: 1, color: '#333333' }}>
                                                                    |
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Box>
                                        </Box>
                                    )}
                                    <Box sx={{ display:{ xs: 'none', md:  'flex'}, alignItems: 'end' }}>
                                        <StatusBadge 
                                            label={dp.order_status}
                                            status={dp.order_status}
                                            size="medium"
                                        />
                                    </Box>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent : 'space-between', alignItems: 'end', width: '100%' }}>
                                    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: {xs:0.5 , md: 4} }}>
                                        {dp.quantity_info && dp.quantity_info.length > 0 && dp.quantity_info.map((quantity, qIndex) => (
                                            <Box key={qIndex} sx={{ display: 'flex', flexDirection: { xs: 'row',md:'column'}, gap: {xs: 2, md: 1} }}>
                                                <Typography variant="labelM" sx={{ color: '#666', minWidth: { xs: '80px', md: '100px' } }}>
                                                    {quantity.label}
                                                </Typography>
                                                <Typography variant="p3">
                                                    {quantity.value}
                                                </Typography>
                                            </Box>
                                        ))}
                                        {dp.remark && (
                                            <Box sx={{ display: {xs: 'flex', md:'none'}, gap: {xs:0.5}, pt:'2px', alignItems: 'center' }}>
                                                <IconReusable name='ErrorFilled' size={16} color='#CC0000' />
                                                <Typography variant="labelM" sx={{ color: '#CC0000', minWidth: { xs: '80px', md: '100px' } }}>
                                                    {dp.remark}
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>
                                    {dp.remark && (
                                        <Box sx={{ display: {xs: 'none', md:'flex'}, gap: {xs:0.5}, pt:'2px', alignItems: 'center' }}>
                                            <IconReusable name='ErrorFilled' size={16} color='#CC0000' />
                                            <Typography variant="labelM" sx={{ color: '#CC0000', minWidth: { xs: '80px', md: '100px' } }}>
                                                {dp.remark}
                                            </Typography>
                                        </Box>
                                    )}
                                    { dp.order_status !== ORDER_STATUS.CANCELLED && (
                                        <Box sx={{ display: 'flex', justifyContent: {xs: 'end', md: 'center'} }}>
                                            <CustomButton
                                                label="View Details"
                                                variant="text"
                                                color="primary"
                                                onClick={() => {
                                                    dispatch(resetDP());
                                                    navigate(`/dispatch-plan-detail/${dp.order_id}`);
                                                    
                                                }}
                                                size={isMobile ? "small" : "medium"}
                                            />
                                        </Box>
                                    )}
                                    
                                </Box>
                            </Box>
                        </Box>
                    ))}
                    {(loading || hasMore) && attachedDPData.length > 0 && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                            <CircularProgress size={24} />
                        </Box>
                    )}
                </Box>
            ) : null}
            {loading && attachedDPData.length === 0 && (
                <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    p: 4,
                }}>
                    <CircularProgress />
                </Box>
            )}

            {/* Empty state */}
            {!loading && (!attachedDPData || attachedDPData.length === 0) && (
                <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                    <IllustrationWrapper
                        illustration={<NoDataFoundSvg />}
                        title="No Dispatch Status found. "
                        subtitle={ selectedStatus.length > 0 ? "Try adjusting your filters." :"No Dispatch Status available yet."}
                    />
                </Box>
            )}
        </Box>
    );
};

export default AttachedDPList;